<template>
  <div>
    <div  v-if="loadings">
      <skeleton-revenue />
    </div>
    <div class="vuse-content-wrapper mt-4">
      <div>
          <v-row >
            <v-col>
              <h2 class="ml-3">
                {{$t(page+'.Countries')}}
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="loadData">
                        <v-icon>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>
            <v-spacer /> 
          </v-row>
          <template v-if="!customers && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5 mt-2">
              <v-col cols="12" md="6" class="mx-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title class="pb-2">
                    <v-row>
                      <v-btn-toggle v-model="selectedArea" @change="search=selectedArea.shippingArea" class="ml-3 mt-3">
                        <template v-for="(c,i) in shippingAreas">
                          <v-tooltip bottom :key="i" max-width="450">
                            <template v-slot:activator="{ on }">
                              <v-btn :key="i" active-class="green" :value="c" v-on="on">
                                <v-div class="float-left">
                                  <v-div>{{c.shippingArea}}</v-div>
                                </v-div>
                              </v-btn>
                            </template>
                            <span>{{c.CountryNames}}</span>
                          </v-tooltip>
                        </template>
                      </v-btn-toggle>
                      <v-spacer></v-spacer>
                      <v-col cols=12 sm="6" lg="3">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            :label="$t(page+'.Search')"
                            single-line
                            hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      
                      fixed-header="true"
                      :headers="i18_headers"
                      :items="customers"
                      :items-per-page="Math.floor((wIH - 335-85.95)/1)"
                      :height="wIH - 335"
                      :search="search"
                      multi-sort
                      class="elevation-1 mx-4"
                      :loading="loading" 
                      loading-text="Loading... Please wait"

                  >
                    <template #item.index="{ item }">
                      {{ customers.indexOf(item)+1 }}
                    </template>

                    <template v-on="on" v-slot:item.countryId="{item}" v-slot:activator="{ on }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                              <v-div class="ml-2">
                                <i :class="'em em-flag-'+item.countryId.toLowerCase()" style="width:48px;height:48px"></i>
                              </v-div>
                              <v-div class="ml-4 text-h6">{{item.countryId}}</v-div>
                          </div>
                        </template>
                        <span>{{item.country}}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.shippingArea="{ item }">
                      <v-text-field 
                        clearable 
                        height="1" 
                        dense 
                        @input.native="save"
                        clear-icon="far fa-trash-alt"
                        @click:clear="save(null,'shippingArea',item.countryId)"  
                        :id="item.countryId" 
                        class="text-h6" 
                        filled  
                        name="shippingArea" 
                        v-model="item.shippingArea"
                        hide-details 
                      ></v-text-field>
                    </template>
                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-snackbar v-model="snackbar" absolute bottom :color="snackbar_color">
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<style scoped>
.v-input__slot{
  min-height:30px!important;
  max-height:20px!important;
}
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import _ from 'lodash'

export default {
  components: { NoData, SkeletonRevenue, ExcelIcon },
  computed : {
    ...mapGetters(["user"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },
  data() {
    return {
      namespace: "Reports",
      page: "BossCountries",
      UserID:null,
      username:'',
      msg_modal:false,
      msg:{},
      loading: true,
      errorid: null,
      simulation:5,
      search: '',
      wIH:window.innerHeight,      
      shippingAreas:[],
      customers: [],
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      headers: [
          { text: 'Country', value: 'countryId',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1','width': '40%'},
          { text: 'Country Name', value: 'country',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1', 'width': '40%'},
          { text: 'Shipping Area', value: 'shippingArea',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1', 'width': '200px' }
        ],      
    };
  },
  created(){
    this.loadData()
  },
  methods:
  {
    save: _.debounce(function (event,field='',id='') {
        this.formReadOnly=true;
        console.log(182,event,field);
        let payload=''
        if (field=='')
        {
          payload={"action":"edit_countries","payload":{"table":"CountryDetails","field":event.target.name,"value":event.target.value,"key":"country","keyValue":event.target.id}};
        }
        else
        {
          payload={"action":"edit_countries","payload":{"table":"CountryDetails","field":field,"value":event,"key":"Country","keyValue":id}};
        }
        console.log(192,payload)
        this.update_db(payload)
    }, 1000), 
    async update_db(payload){
      let jwt=sessionStorage.getItem('jwt');
      try{
          console.log(199,payload);
          
          const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':payload});
          console.log(202,res.data);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(417,payload.value);
              console.log(418,res.data.payload[res.data.payload.field]);
              //console.log(252,payload.id,res.data.payload,this.isJson(res.data.payload),this.customers)
              /*if (res.data.payload!='0')
              {
                this.customers.unshift(JSON.parse(res.data.payload));
                console.log(254,this.customers);
              }*/
             break;
          }
          return res.data;
      } 
      catch(e)
      {
        console.log(e);
          this.snackbar_color='red darken-2';
          this.snackbar_text='Connection Error - Try Later';
      }
      this.snackbar=true;
      return null;
    },
    isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
    },
     openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;

    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try
      {
          const res = await this.$http.post('/boss/countries.php', {"jwt":jwt});
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payload.table;
              this.shippingAreas=res.data.payload.shippingAreas;
              //console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
    async impersonate(e,p)
    {
      if(p)
      {
        this.loader=true;    
    	  //localStorage.clear();
	      localStorage.removeItem('user');
	      //sessionStorage.clear();
	      sessionStorage.removeItem('jwt');
        try
        {
          const res = await this.$http.post('/auth/login.php', {email: e, password: p, rememberme: true})
          this.errorid=res.data.errorid;
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            res.data.user.jwt=res.data.jwt;
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setFixings", res.data.fixings);
            //this.$store.dispatch("setLocale", res.data.user.locale);
            //this.$store.dispatch("setCurrency", res.data.user.currency);
            //this.$store.dispatch("set_timeframe", res.data.user.timeframe); 
            
            if (res.data.ls_user)
            {
              localStorage.setItem('user', JSON.stringify(res.data.ls_user));
              //localStorage.setItem('user', res.data.user);
            }
            else
            {
              localStorage.removeItem('user');
            }
            this.$router.push('/'+res.data.user.landingpage).catch(() => {});
          }
          else
          {
            this.message=res.data.message;
            this.dialog=true;
          }
        }       
        catch(e)
        {
          this.$router.push('/auth/login').catch(() => {});
        }
        this.loader=false;
      }
      else
      {
        this.snackbar=true;
        this.snackbar_text='Missing PWD';
        this.snackbar_color='red';
      }
    },
  }
};
</script>